module.exports = __webpack_public_path__ + "assets/d603233a.wav";